import { Capacitor } from '@capacitor/core';

/**
 * Use this for layout decisions (mobile shell, header, tabs) so we can
 * preview the native UI in the browser during development.
 *
 * Returns true when:
 * - Running inside Capacitor (real Android/iOS), or
 * - In dev (Vite): URL has ?native=1 or localStorage has ggj_simulate_native=true
 *
 * To preview native UI in browser: open http://localhost:5173/?native=1
 * or run in console: localStorage.setItem('ggj_simulate_native', 'true'); location.reload();
 */
export function isNativePlatform(): boolean {
  if (Capacitor.isNativePlatform()) return true;
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    try {
      if (localStorage.getItem('ggj_simulate_native') === 'true') return true;
      if (window.location.search.includes('native=1')) return true;
    } catch {
      // ignore
    }
  }
  return false;
}
